import React from 'react';
import "./_comLoader.scss"

function ComLoader({}) {
  return (
    <div className="com-loader"></div>
  );
}

export default ComLoader;